<section class="time-per-stage">
  <header class="time-per-stage-title">{{ title }}</header>

  <ol
    class="time-per-stage-timeline"
    aria-label="Etapas percorridas, da primeira à atual">
    @for (item of displayItems; track item.label) {
      <li
        class="time-per-stage-step"
        [class.time-per-stage-step--current]="item.current"
        [style.--stage-color]="item.color">
        <span
          class="time-per-stage-dot"
          aria-hidden="true"></span>
        <span class="time-per-stage-label">
          {{ item.label }}
          @if (item.current && displayItems.length > 1) {
            <span class="time-per-stage-current">atual</span>
          }
        </span>
        <span class="time-per-stage-value">{{ item.time }}</span>
      </li>
    }
  </ol>

  <div class="time-per-stage-total">
    <span class="time-per-stage-footer-label">{{ totalLabel }}</span>
    <span class="time-per-stage-footer-value">{{ displayTotal }}</span>
  </div>

  @if (data.footnote) {
    <p class="time-per-stage-footnote">{{ data.footnote }}</p>
  }
</section>
